import { localize } from '../../i18n';
import React from 'react';
import { Box } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import SingleLineText from './SingleLineText';
import { openDatePickerOnClick } from '../../utils/datePicker';

const hiddenDateInputStyle = {
    position: 'absolute',
    inset: 0,
    width: '100%',
    height: '100%',
    opacity: 0,
    cursor: 'pointer',
    border: 0,
    background: 'transparent',
    color: 'transparent',
    fontSize: 16,
    zIndex: 2,
};

function formatDate(dateKey) {
    if (!dateKey) return '';
    const [year, month, day] = dateKey.split('-');
    return localize("{v0}년 {v1}월 {v2}일", { v0: year.slice(-2), v1: Number(month), v2: Number(day) });
}

export default function DateInputCard({
    label, ariaLabel, id, value, onChange, min, max, disabled = false, tabIndex = -1, minHeight = 74,
    valueFontSize = '0.98rem', labelColor = '#888', valueColor = '#1f1f1f', sx,
}) {
    return (
        <Box sx={{
            minHeight, px: 1.25, py: 1.1, borderRadius: 3,
            bgcolor: disabled ? '#f7f7f7' : '#fff', border: '1px solid #eeeeee',
            boxShadow: '0 1px 0 rgba(0,0,0,0.02)',
            cursor: disabled ? 'default' : 'pointer', position: 'relative', minWidth: 0,
            '&:active': disabled ? {} : { bgcolor: '#f9fafb' },
            ...sx,
        }}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 0.5 }}>
                <SingleLineText sx={{ fontSize: '0.82rem', color: labelColor, fontWeight: 800, lineHeight: 1.2 }}>
                    {label}
                </SingleLineText>
                {!disabled && <ChevronRightIcon sx={{ fontSize: 17, color: '#b8b8b8', flexShrink: 0 }} />}
            </Box>
            <SingleLineText sx={{ mt: 0.7, fontSize: valueFontSize, color: disabled ? '#555' : valueColor, fontWeight: 850, lineHeight: 1.4 }}>
                {disabled ? localize('없음') : formatDate(value)}
            </SingleLineText>
            {!disabled && <input
                id={id}
                type="date"
                value={value}
                onChange={onChange}
                onClick={openDatePickerOnClick}
                min={min}
                max={max}
                style={hiddenDateInputStyle}
                aria-label={ariaLabel || label}
                tabIndex={tabIndex}
            />}
        </Box>
    );
}
